/**
 * The report-type identity stamped onto every generated sheet's custom properties and read back by
 * `getSheetsByReportType`. Each of these is named in the generator, the registry, the template
 * builder and the taskpane, and all four must agree: a sheet whose stored type stops matching still
 * exists but becomes invisible to refresh and delete.
 */
export const AREA_SHEET_REPORT_NAME = "Area Sheet";
export const UNIT_MIX_REPORT_NAME = "Unit Mix";
export const ROOMS_REPORT_NAME = "Rooms";
